export const name = "SPLIT";
export const summary = `Splits a \`STRING\` or \`BYTES\` value, using a delimiter.`;
export const reference = `
## SPLIT

Splits a \`STRING\` or \`BYTES\` value, using a delimiter.

\`\`\`
SPLIT(value[, delimiter])
\`\`\`

### Description

Splits a \`STRING\` or \`BYTES\` value, using a delimiter. The \`delimiter\` argument must be a literal character or sequence of characters. You can't split with a regular expression.

For \`STRING\`, the default delimiter is the comma \`,\`.

For \`BYTES\`, you must specify a delimiter.

Splitting on an empty delimiter produces an array of UTF-8 characters for\`STRING\` values, and an array of \`BYTES\` for \`BYTES\` values.

Splitting an empty \`STRING\` returns an\`ARRAY\` with a single empty\`STRING\`.

This function supports specifying collation.


### Return type

\`ARRAY<STRING>\` or \`ARRAY<BYTES>\`


### Examples



\`\`\`
WITH letters AS
  (SELECT '' as letter_group
  UNION ALL
  SELECT 'a' as letter_group
  UNION ALL
  SELECT 'b c d' as letter_group)

SELECT SPLIT(letter_group, ' ') as example
FROM letters;

/*----------------------*
 | example |
 +----------------------+
 | [] |
 | [a] |
 | [b, c, d] |
 *----------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
